module.exports = __webpack_public_path__ + "static/og-8141c0a176d2868a49fee8ad25b7ca9e.png";